import { ProgressMeter } from "../../progress-meter";
import type { ProgressMeterProps } from "../../progress-meter/progress-meter";

export function DataTableProgressMeter(props: ProgressMeterProps) {
	/** Render */
	return (
		<div className="absolute inset-y-0 inset-x-3 flex-center">
			<ProgressMeter {...props} />
		</div>
	);
}
